import { CustomSelect } from '..'
import { providers as providersList } from '@indigohive/cogfy-providers'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { WorkspaceUsageContext } from '../../pages/WorkspaceUsagePage/WorkspaceUsagePage'
import { useFilters } from '../../hooks'

export type FilterDrawerStackProps = {
  filtersHook: ReturnType<typeof useFilters>
  renderCollection?: boolean
  renderProvider?: boolean
}

export function FilterDrawerStack (props: FilterDrawerStackProps) {
  const { filtersHook, renderCollection, renderProvider } = props
  const { filters, addFilter } = filtersHook

  const { t } = useTranslation()
  const context = useOutletContext<WorkspaceUsageContext>()

  const collection = filters.find(f => f.name === t('Collection'))
  const provider = filtersHook.filters.find(f => f.name === t('Provider'))

  const collectionOptions = context?.collections?.length > 0
    ? [{ label: t('All'), value: undefined }, ...context.collections.flatMap(collection => ({ label: collection.name || t('common:Untitled'), value: collection.id }))]
    : [{ label: t('All'), value: undefined }]

  const handleCollectionChange = (value?: string) => {
    const filteredCollection = context?.collections?.find(p => p.id === value)

    if (filteredCollection) {
      addFilter({ name: t('Collection'), valueLabel: filteredCollection?.name || t('Untitled'), value: filteredCollection?.id })
    } else {
      addFilter({ name: t('Collection'), valueLabel: t('All'), value: undefined })
    }
  }

  const providers = providersList?.flatMap(item => ({
    label: item.label,
    value: item.name
  })) || []

  const providerOptions = [{ label: t('All'), value: undefined }, ...providers]

  return (
    <div className='flex flex-col w-full gap-3'>
      {renderCollection && (
        <div className="pt-0 mt-0 flex flex-col content-start">
          <CustomSelect
            label={t('Collection')}
            onChange={value => { handleCollectionChange(value) }}
            value={collection?.value}
            options={collectionOptions}
            showOptionValues={false}
            buttonClassName='w-full'
          />
        </div>
      )}

      {renderProvider && (
        <div className="pt-0 mt-0 flex flex-col content-start">
          <CustomSelect
            label={t('Provider')}
            onChange={value => {
              const providerFinded = providerOptions.find(p => p.value === value)

              if (providerFinded) {
                addFilter({ name: t('Provider'), valueLabel: providerFinded.label, value })
              } else {
                addFilter({ name: t('Provider'), valueLabel: t('All'), value: undefined })
              }
            }}
            value={provider?.value}
            options={providerOptions}
            showOptionValues={false}
            buttonClassName='w-full'
          />
        </div>
      )}
    </div>
  )
}
